import React, { useEffect } from 'react'
import './navbar.css'

const Navbar = ({setBars, bars}) => {
  const mediaQuery = window.matchMedia("(min-width: 280px) and (max-width: 800px)");

useEffect(()=> {
  const mediaQuery2 = window.matchMedia("(min-width: 801px) and (max-width: 2000px)");

  function secondMedia (event) {
    if(event.matches===true) {
    setBars(true)
    }
  }

  mediaQuery2.addEventListener('change', secondMedia)
  secondMedia(mediaQuery2)
  return () => {
    mediaQuery2.removeEventListener('change', secondMedia)
  }

}, )


  function handleScreenChange(event) {
    if (event.matches===true) {
      setBars(false)
    } 
    else {
      setBars(true)
  }}
  mediaQuery.addEventListener("change", handleScreenChange);

  const workingSideBar = () => {
    if(bars===true) {
      setBars(false)
    } else{
      setBars(true)
    }
  }
  return (
    <>
    <div className='navbar'>
        <nav className='navbarItems'>
           <h1 className='barsLogo' onClick={()=>{
            workingSideBar()
            }}>☰</h1>
           <h1>ChatGPT</h1>
        </nav>
    </div>
    </>
  )
}

export default Navbar
